module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "400"
    },
    model: {
      value: (_vm.$parent.popup.isVisible),
      callback: function($$v) {
        _vm.$parent.popup.isVisible = $$v
      },
      expression: "$parent.popup.isVisible"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "trHeader",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$parent.popup.title))])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n              שם תוכנית\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.Name),
      expression: "$parent.popup.data.Name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$parent.popup.data.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.popup.data.Name = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n              תיאור תוכנית בנייה\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.Info),
      expression: "$parent.popup.data.Info"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.$parent.popup.data.Info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.popup.data.Info = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n              פרויקט\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "custom-dropdown custom-dropdown--white",
    staticStyle: {
      "width": "200px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.ProjectKey),
      expression: "$parent.popup.data.ProjectKey"
    }],
    staticClass: "custom-dropdown__select custom-dropdown__select--white",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$parent.popup.data.ProjectKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.setProjectName]
    }
  }, _vm._l((_vm.projects), function(project) {
    return _c('option', {
      domProps: {
        "value": project['.key']
      }
    }, [_vm._v(_vm._s(project.Name))])
  }))])])], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "10px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "error"
  }, [_vm._v("* " + _vm._s(_vm.error))])])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding": "0px 50px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._v("\n          אחרי שמירת שם ותיאור תוכנית בניית ניתן לצרף מסמכים לתוכנית\n        ")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.canEdit) ? _c('v-flex', {
    staticStyle: {
      "padding-bottom": "20px"
    },
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    staticClass: "green green--text ml-3",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.save($event)
      }
    }
  }, [_vm._v("\n            שמירה\n            "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "red red--text ml-2",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancel($event)
      }
    }
  }, [_vm._v("\n            ביטול\n            "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("block")])], 1)], 1) : _c('v-flex', {
    staticStyle: {
      "padding-bottom": "20px"
    },
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    staticClass: "red red--text ml-2",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancel($event)
      }
    }
  }, [_vm._v("\n            סגור חלון\n            "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("cancel")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49a1be1e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PopupPlan.vue
// module id = 885
// module chunks = 2